import React from 'react'
import AboutSection from '../components/AboutSection'
import Footer from '../components/Footer'
// import WhyChoose from '../components/WhyChoose'
// import DemoForm from '../components/DemoForm'

const About = () => {
  return (
    <div>
        <AboutSection/>
        {/* <WhyChoose/> */}
        {/* <DemoForm/> */}
        <Footer/>

    </div>
  )
}

export default About